import React, { useContext, useEffect, useState } from 'react'
import { Dropdown, Nav } from "react-bootstrap";
import overviewIcon from "assets/images/svg/OverviewIcon.svg";
import DiscoverIcon from "assets/images/svg/DiscoverIcon.svg";
import IncidentsIcon from "assets/images/svg/IncidentsIcon.svg";
import MitigateIcon from "assets/images/svg/MitigateIcon.svg";
import RevertIcon from "assets/images/svg/RevertIcon.svg";
import styles from "../../RiskHealth.module.scss";
import AppDataContext from 'context/AppDataContext';


export default function RiskHeader({ addToDashboard, openGrid, onTabNav, tabNav, collaboratorHandler }: any) {
  const [activeTab, setActiveTab] = useState("Overview");

  useEffect(() => {
    setActiveTab(tabNav);
  }, [tabNav]);



  return (
    <header className={styles.tabHeader}>
      <h2 className={styles.tabHeaderTitle}>Risk Health</h2>

      <Nav variant="tab" className={styles.tabNav}>
        <Nav.Item>
          <Nav.Link
            aria-selected={activeTab === "Overview"}
            onClick={() => {
              onTabNav("Overview");
              setActiveTab("Overview");
            }}
          >
            <img src={overviewIcon} alt="overview" />
            <h3 className="fw-300 text-gray-50 mt-2">Overview</h3>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link
            aria-selected={activeTab === "Discover"}
            onClick={() => {
              onTabNav("Discover");
              setActiveTab("Discover");
            }}
          >
            <img src={DiscoverIcon} alt="Discover" />
            <h3 className="fw-300 text-gray-50 mt-2">Discover</h3>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            aria-selected={activeTab === "Incidents"}
            onClick={() => {
              onTabNav("Incidents");
              setActiveTab("Incidents");
            }}
          >
            <img src={IncidentsIcon} alt="Incidents" />
            <h3 className="fw-300 text-gray-50 mt-2">Incidents</h3>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            aria-selected={activeTab === "Mitigate"}
            onClick={() => {
              onTabNav("Mitigate");
              setActiveTab("Mitigate");
            }}
          >
            <img src={MitigateIcon} alt="Mitigate" />
            <h3 className="fw-300 text-gray-50 mt-2">Mitigate</h3>
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <div className="d-inline-flex">
        <button
          onClick={() => addToDashboard()}
          className="btn btn-flat text-white"
        >
          <i className="icon-plus text-2x"></i>
        </button>
        <button
          onClick={() => openGrid()}
          className="btn btn-flat text-white mr-3"
        >
          <i className="icon-grid text-2x"></i>
        </button>
        <Dropdown>
          <Dropdown.Toggle size="lg" variant="outline-secondary">
            Present
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>
              <div className="d-flex align-items-center pv-2">
                <span
                  className="circle text-white bg-gray-800 mr-3"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    overflow: "visible",
                  }}
                >
                  <img
                    src={RevertIcon}
                    style={{ width: "1.25rem" }}
                    alt="Strategy"
                  />
                </span>
                <div className="text-gray-50">
                  <h5 className="mb-0">Create a Presentation</h5>
                  <small className="text-gray-400">
                    Create a slide deck with this information
                  </small>
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item>
              <div className="d-flex align-items-center pv-2">
                <span
                  className="circle text-white bg-gray-800 mr-3"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    overflow: "visible",
                  }}
                >
                  <img
                    src={RevertIcon}
                    style={{ width: "1.25rem" }}
                    alt="Strategy"
                  />
                </span>
                <div className="text-gray-50">
                  <h5 className="mb-0">Virtual Report</h5>
                  <small className="text-gray-400">
                    Create an interactive report and share with users
                  </small>
                </div>
              </div>
            </Dropdown.Item>
            <Dropdown.Item>
              <div
                className="d-flex align-items-center pv-2"
                onClick={() => collaboratorHandler()}
              >
                <span
                  className="circle text-white bg-gray-800 mr-3"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    overflow: "visible",
                  }}
                >
                  <img
                    src={RevertIcon}
                    style={{ width: "1.25rem" }}
                    alt="Strategy"
                  />
                </span>
                <div className="text-gray-50">
                  <h5 className="mb-0">Real Time Collaborator</h5>
                  <small className="text-gray-400">
                    Collaborate in real time on this report
                  </small>
                </div>
              </div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
}
